import React from 'react';
import { motion } from 'framer-motion';
import { Reveal, RevealLines } from './Reveal';
import { REVIEWS } from '../data/site';
import { Quote } from 'lucide-react';

export default function Reviews() {
  return (
    <section id="reviews" className="relative py-32 md:py-48 border-y border-char/10" data-testid="reviews-section">
      <div className="px-6 md:px-10 max-w-[1600px] mx-auto">
        <div className="grid grid-cols-12 gap-6 md:gap-10 mb-16">
          <Reveal className="col-span-12 md:col-span-3">
            <div className="flex md:flex-col items-baseline md:items-start gap-4">
              <span className="font-mono text-gold text-sm tracking-[0.3em]">06 —</span>
              <span className="overline">Avis clients</span>
            </div>
          </Reveal>
          <div className="col-span-12 md:col-span-9">
            <h2 className="font-serif leading-[0.95] tracking-tight" style={{ fontSize: 'clamp(2.5rem, 6vw, 6rem)' }}>
              <RevealLines lines={['Ils en parlent', <span key="i" className="italic text-char/50">mieux que nous.</span>]} />
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-char/10">
          {REVIEWS.map((r, i) => (
            <motion.blockquote
              key={r.name}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-10% 0px' }}
              transition={{ duration: 0.8, delay: (i % 2) * 0.1 }}
              className="relative bg-cream p-8 md:p-12"
              data-testid={`review-${i}`}
            >
              <Quote className="text-gold/40 mb-6" size={28} strokeWidth={1} />
              <p className="font-serif text-2xl md:text-3xl leading-snug text-char/90">
                &laquo; {r.text} &raquo;
              </p>
              <footer className="mt-8 flex items-center gap-4">
                <span className="w-10 h-px bg-gold" />
                <div>
                  <div className="text-char">{r.name}</div>
                  <div className="overline mt-0.5">{r.role}</div>
                </div>
              </footer>
            </motion.blockquote>
          ))}
        </div>
      </div>
    </section>
  );
}
